<!-- 作业辅导 -->
<template>
  <div class="container">
    <div class="index" v-show="!detail.show">
      <div class="title">
        <span>{{$route.name}}</span>
      </div>

      <header>
        <div class="header-item" style="width:25%">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>学生参与情况</span>
          </div>
          <div id="echarts-box1" class="m-t"></div>
        </div>

        <div class="header-item" style="width:25%">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>教师参与情况</span>
          </div>
          <div id="echarts-box2" class="m-t"></div>
        </div>

        <div class="header-item" style="width:50%">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>课程报名率统计</span>
            <el-radio-group v-model="radio1" class="m-l">
                <el-radio-button label="参与率前十名"></el-radio-button>
                <el-radio-button label="参与率后十名"></el-radio-button>
            </el-radio-group>
          </div>
          <div class="Homeboxtop_nav_tab m-t m-l">
            <span v-for="(item, index) in tabList" :class="['res-tab', { active: item.name === tabName1 }]" :key="index" @click="tabClick1(item)">
                {{ item.name }}
            </span>
          </div>
          <div id="echarts-box3" class="m-t"></div>
        </div>
      </header>
      
      <!-- 表格 -->
      <div class="header-item-title" style="margin-top:40px">
        <span class="circle"></span>
        <span>作业辅导情况统计</span>
      </div>
      <el-form ref="form" :inline="true" :model="form" label-width="45px" style="margin-top:36px">
        <el-form-item label="">
            <el-select v-model="form.schoolYearSemester" placeholder="请选择学年学期" clearable>
                <el-option v-for="item in semesterList" :key="item.id" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="form.grade" clearable placeholder="请选择">
            <el-option v-for="item in gradeList" :key="item.id" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程日期" label-width="70px">
			<el-date-picker v-model="form.date" type="date" style="width: 240px;" placeholder="请选择">
			</el-date-picker>
		</el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" @click="getDataList">搜索</el-button>
        </el-form-item>
      </el-form>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column align="center" prop="a" label="班级名称">
          </el-table-column>
          <el-table-column align="center" prop="b" label="辅导教师">
          </el-table-column>
          <el-table-column align="center" prop="c" label="学生人数">
          </el-table-column>
          <el-table-column align="center" prop="d" label="学生参与人数">
          </el-table-column>
          <el-table-column align="center" prop="e" label="参与率">
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <!-- <el-pagination
        background
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination> -->
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  components: {

  },
  data() {
    return {
      form: {
        schoolYearSemester: "",
        orgId: "",
        grade:'',
        date:'',
      },
      gradeList:[
        {id:'g1',label:'一年级'},
		{id:'g2',label:'二年级'},
		{id:'g3',label:'三年级'},
		{id:'g4',label:'四年级'},
		{id:'g5',label:'五年级'},
		{id:'g6',label:'六年级'},
      ],
      semesterList: [
        {id:'xq1',label:'2021~2022年度下学期'},
		{id:'xq2',label:'2021~2022年度上学期'},
		{id:'xq3',label:'2020~2021年度下学期'},
		{id:'xq4',label:'2020~2021年度上学期'},
		{id:'xq5',label:'2019~2020年度下学期'},
		{id:'xq6',label:'2019~2020年度上学期'},
      ],
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },
      tableData: [
        {a:'三年级1班',b:'刘禹锡、张珊珊',c:'40',d:'20',e:'50%'},
        {a:'四年级1班',b:'刘禹锡、张珊珊',c:'40',d:'20',e:'50%'},
        {a:'五年级1班',b:'陈诗慧',c:'40',d:'20',e:'50%'},
        {a:'六年级1班',b:'徐明路',c:'40',d:'20',e:'50%'},
      ],
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList"))||[],
      userInfo:JSON.parse(sessionStorage.getItem('userInfo')),
      detail: {
        info: {},
        show: false,
      },
      radio1:'参与率前十名',
      tabList: [{ name: "本周" }, { name: "本月" },{ name: "本学期" }, { name: "本年度" },],
      tabName:'本周',
      tabName1:'本周',
    };
  },
  mounted() {
    this.init();
  },
  created(){
  },
  methods: {
    tabClick(item) {
	 this.tabName = item.name;
    },
    tabClick1(item) {
	 this.tabName1 = item.name;
    },
    tabClick2(item) {
 	 this.tabName2 = item.name;
    },
    tabClick3(item) {
	 this.tabName3 = item.name;
    },
    async getDataList() {
      
    },
    searchFun(){
      this.page.pageNum=1;
	  this.getDataList();
    },
    sizeChangeHandle(val) {
      this.page.pageNum=1
      this.page.pageSize = val;
      this.getDataList()
    },
    currentChangeHandle(val) {
      this.page.pageNum=1
      this.page.pageNum = val;
      this.getDataList()
    },
    toDetail(scope) {
      console.log(scope);
      this.detail.info = scope.row;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
    init(){
      let vm = this;
      this.$nextTick(() => {
        // 圆环图
        let chartDom1 = document.getElementById('echarts-box1');
        let myChart1 = echarts.init(chartDom1);
        let option1 = {
            legend: {
					// data: [],
					// orient: 'vertical',
					left: 'center',
					top: 'bottom',
					icon : 'circle',
			},
            title: {
			    zlevel: 0,
				text: [
					'{value|' + '56%' + '}',
				],
				rich: {
					value: {
						color: '#333333',
						fontSize: 24,
						fontWeight: 'bold',
						lineHeight: 24,
					},
					name: {
						color: '#666666',
						fontSize: 14,
					},
				},
				top: 'center',
				left: '95',
				textAlign: 'center',
				textStyle: {
					rich: {
						value: {
							color: '#333333',
							fontSize: 24,
							fontWeight: 'bold',
							lineHeight: 24,
						},
					name: {
							color: '#666666',
							lineHeight: 20
						},
					},
				},
			},
			series: [
				{
					name: '',
					type: 'pie',
					radius: ['42%', '60%'], // 这个属性修改环形宽度
					avoidLabelOverlap: false,
					itemStyle: {
						borderRadius: 0,
						borderColor: '#fff',
						borderWidth: 0,
					},
					label: {
						show: false,
						position: 'center',
					},
					emphasis: {
						label: {
						show: false,
						fontSize: '16',
						fontWeight: 'bold',
						},
					},
					labelLine: {
						show: false,
					},
					data: [
						{ value: 56, name: '已参与学生数' },
						{ value: 44, name: '未参与学生数' },
					],
				},
			],
			// 圆环颜色
			color: ['#51D6A6', '#5BB0FF', ],
        };
        myChart1.setOption(option1);

        // 圆环图
		let chartDom2 = document.getElementById('echarts-box2');
		let myChart2 = echarts.init(chartDom2);
		let option2 = {
			legend: {
					// data: [],
					// orient: 'vertical',
					left: 'center',
					top: 'bottom',
					icon : 'circle',
			},
            title: {
			    zlevel: 0,
				text: [
					'{value|' + '43%' + '}',
				],
				rich: {
					value: {
						color: '#333333',
						fontSize: 24,
						fontWeight: 'bold',
						lineHeight: 24,
					},
					name: {
						color: '#666666',
						fontSize: 14,
					},
				},
				top: 'center',
				left: '95',
				textAlign: 'center',
				textStyle: {
					rich: {
						value: {
							color: '#333333',
							fontSize: 24,
							fontWeight: 'bold',
							lineHeight: 24,
						},
					name: {
							color: '#666666',
							lineHeight: 20
						},
					},
				},
			},
			series: [
				{
					name: '',
					type: 'pie',
					radius: ['42%', '60%'], // 这个属性修改环形宽度
					avoidLabelOverlap: false,
					itemStyle: {
						borderRadius: 0,
						borderColor: '#fff',
						borderWidth: 0,
					},
					label: {
						show: false,
						position: 'center',
					},
					emphasis: {
						label: {
						show: false,
						fontSize: '16',
						fontWeight: 'bold',
						},
					},
					labelLine: {
						show: false,
					},
					data: [
						{ value: 43, name: '已参与教师数' },
						{ value: 57, name: '未参与教师数' },
					],
				},
			],
			// 圆环颜色
			color: ['#51D6A6','#5BB0FF',],
		};
		myChart2.setOption(option2);

        // 柱状图
        let chartDom3 = document.getElementById('echarts-box3');
        let myChart3 = echarts.init(chartDom3);
        let option3 = {
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['张珊珊', '陈诗慧', '王玉路', '陈思成', '陈慧语', '叶惠晨', '徐明语', '陈辉英'],
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [10, 8, 6, 5, 4, 6, 5, 3	],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: '#5BB0FF' },
                  ]),
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999"
                    }
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart3.setOption(option3);
      });
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner {
  width: 189px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 0 0 2% 2%;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}

.header-item-title{
    font-size: 18px;
    color: #333;
    display: flex;
    align-items: center;
    .circle{
        width: 8px;
        height: 8px;
        display: inline-block;
        background: #4991e1;
        border-radius: 50%;
        margin-right: 10px;
    }
}
header{
    width: 100%;
    height: 430px;
    display: flex;

    .header-item{
      overflow-x: auto;
      .header-item-text{
        font-size: 14px;
        color: #666;
        padding-left: 20px;
        margin-top: 5px;
      }
    }
    #echarts-box1, #echarts-box2{
      width:200px;
      height:280px;
    }
    #echarts-box3{
      width:750px;
      height:280px;
    }
}
::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner{
    color: #409EFF;
    background: #ffffff;
}
::v-deep .el-radio-button .el-radio-button__inner{
    height: 32px;
    padding: 8px;
    color: #999999;
}
.m-l{
    margin-left: 20px;
}
.m-t{
    margin-top: 20px;
}
.m-b{
    margin-bottom: 20px;
}
</style>
